import { lazy } from 'react';

// After an update is published, old page files no longer exist, so a browser
// still running the previous version fails to load them. Reload once to pick
// up the new version instead of showing an error.
export default function lazyRetry(importer) {
  return lazy(() => importer().then((mod) => {
    sessionStorage.removeItem('chunk_reload');
    return mod;
  }).catch((err) => {
    if (!sessionStorage.getItem('chunk_reload')) {
      sessionStorage.setItem('chunk_reload', '1');
      window.location.reload();
      return new Promise(() => {});
    }
    throw err;
  }));
}